import { type ExprNode } from '@learnforge/demo-math/expr';
import { formalDerivative } from './derivative';
import { evaluate } from './evaluate';
import { findZerosBisection } from './zeros';

export interface Extremum {
  x: number;
  y: number;
  kind: 'min' | 'max' | 'inflection';
}

export function findExtrema(node: ExprNode, a: number, b: number): Extremum[] {
  const d1 = formalDerivative(node);
  const d2 = formalDerivative(d1);
  const critical = findZerosBisection(d1, a, b);
  const out: Extremum[] = [];
  for (const x of critical) {
    const y = evaluate(node, x);
    const concavity = evaluate(d2, x);
    let kind: Extremum['kind'];
    if (Math.abs(concavity) < 1e-6) kind = 'inflection';
    else if (concavity > 0) kind = 'min';
    else kind = 'max';
    out.push({ x, y, kind });
  }
  return out;
}
